var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0V0Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_87",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_87",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAAAAAAfl4auAAACeElEQVRIx+2WIZqrQBCEc4CokSPnBJwAj+UCozlADoDLCTgAHoPCxEdjMMjRo8a0qOonhrDZfG/f8r0Va1IWfrq7pho46Q90esNv+Fdh/gpMkv/bNvEjGMdhUqlKJQDidimsLS5jBBX8HgYIIQVE6qz1l7Zxtg0AjrRNBUAqkjdtoCpib8vIQ5UJABJj6kybBBCoDK4VOVCZwtDXzhhn2gQAVIGOdjzSNjiXtm77oW2CQEBVUFPpmWJUkODn8T/N3Nv6LlQSBJFDItKbwpxN2UW+OvcMr64KQupG5oxB16bp+q62TSA+W/cEJ18sIjmVpIpIikkAABTI5Kqk8lXluWiFICDZ9rnzVd0MASKEqAx2eDmz02N3yJu5Z4tJgql3rvK+cvYaASo0XcoAhapCFYodJsj+vBJkHK6Xdoq98/ckEu/tucnN8m5vUEABJRR8wCI3b8skTFfniqq0hamzd9Ch6HKX4i79MN3mKPnSDveu6FdFulp/X2MYa7+SBBUi93W7yVtjjC2qMQlkbxtX20UI0Ns+QUUFIiTInAzk2STGGObBOx8BbjBne0kEibYRgFRCBJkFKLsxAhKpcx1A6IkAk68j//26el5clbYMzDODa9EBOAYrQAzF/HCbS9Ejn+ChyoK+WKjUE6kIZStysDJASFMFEHpSktK5LskxWIDUuVGY3aZqrKzv5mX+i5ZlWdasEEIIYRka5yNU94TFrnTm/IWMOZ/NQ9YW1RCVKh/ZlnCfxuFF4zAO4ziO4zRN03TbtESAeIJziPYvxLbSn9//WdhSy30lhcQWklfu45EbnEtR9bEYCvn2fF8OY8/2+5/kDb/hN/wHEkM4iqD9Ym0AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.7ecfc56451212dae2af78b8b561376fe.svg";
export { ForwardRef as ReactComponent };